export default "__VITE_ASSET__YgYuxHY1__"